/**
 * Simple, clean node defaults for ELK layout
 * Estimates dimensions based on content to prevent overlapping
 */

export const NODE_DEFAULTS = {
  width: 420, // Standard width for most nodes
  minHeight: 80, // Minimum height for empty nodes
  maxWidth: 420, // Maximum width for text wrapping (used in CSS)
  lineHeight: 18,
  basePadding: 35,
} as const
